<template>
  <v-container fluid style="height: inherit; background-color: rgb(0 0 0 / 5%); overflow-y: auto;" class="pa-0">
    <!--
    <v-row no-gutters>
      <v-col cols="8">
      -->
    <ContractOrdersGraph :past-orders="pastOrdersPlain" :next-orders="[]" />
    <!--
      </v-col>
      <v-col cols="4" class="px-3">
        <v-card>next order date</v-card>
        <v-card>next order amount</v-card>
        <v-card>total invoiced</v-card>
      </v-col>
    </v-row>
    -->

    <v-row no-gutters class="pa-3">
      <v-col>
        <v-row no-gutters align="center">
          <v-col cols="0">
            <h3 v-text="'Next order'" />
            {{ formatCurrencyTotal(TotalAmountNextOrders) }}
          </v-col>
          <v-col cols="auto">
            <QDateField3 v-model="nextDate" :placeholder="$t('servicesystem.common_objects.commonterms.today')"
              externaledit clearable class="mt-n2">
            </QDateField3>
          </v-col>
          <v-col v-if="nextOrders.length > 0" cols="auto" class="ml-3 mt-1">
            <v-btn :color="generateLoading ? 'disabled' : 'primary'" :disabled="generateLoading || !HasLines || IsWorking"
              :loading="generateLoading" small @click="generateNextOrder">
              Generate order
            </v-btn>
          </v-col>
        </v-row>

        <ContractOrderCardHeader :loading="isLoading || nextLoading" />
        <div v-for="nextOrder in nextOrders" :key="nextOrder.CustomerId">
          <ContractPaymentPlanPreviewCard :item="nextOrder">
          </ContractPaymentPlanPreviewCard>
        </div>

      </v-col>
    </v-row>

    <v-row no-gutters class="pa-3">
      <v-col>
        <h3 v-text="'Past orders'" />

        <template v-if="pastOrders && pastOrders.length">
          <ContractOrderCardHeader :loading="isLoading || pastLoading" />
          <ContractOrderCard v-for="meta in pastOrders" :key="meta.OrderId" :order="meta.Order">
          </ContractOrderCard>
        </template>

        <div v-else class="py-1">
          No past orders
        </div>
      </v-col>
    </v-row>

  </v-container>
</template>


<script>
import clientAPI from "@/api/ClientAPIMixin";
import ContractPaymentPlanPreviewCard from './ContractPaymentPlanPreviewCard.vue';
import ContractOrderCard from './ContractOrderCard.vue';
import ContractOrderCardHeader from "./ContractOrderCardHeader.vue";
import QDateField3 from "@/components/Inputs/QDateField3.vue";
import ContractOrdersGraph from "./ContractOrdersGraph.vue";
import SRConst from "@/helpers/Constants/SignalRConstants.js";

export default {
  name: 'ViewContractOrders',
  props: {},
  components: {
    ContractOrderCard,
    ContractPaymentPlanPreviewCard,
    ContractOrderCardHeader,
    QDateField3,
    ContractOrdersGraph,
  },
  mixins: [clientAPI],

  data() {
    return {
      initiated: false,
      isLoading: false,
      nextLoading: false,
      pastLoading: false,
      generateLoading: false,
      valid: false,
      editMode: false,
      edittrigger: 1,
      pastOrders: [],
      nextOrders: [],
      nextDate: null,
    };
  },

  mounted() {
    this.fetch();
    this.$store.dispatch("NotificationStore/subscribe", [
      SRConst.EventKeys.ContractOrderEvent,
      this.notifyChanges
    ]);
  },

  methods: {
    notifyChanges(args) {
      // list of planIds that changed
      const planIds = args.paymentPlansId;
      const status = args.status;
      // find any plans with id
      const affectedNextOrders = this.nextOrders.filter(no =>
        no.Details.some(d => planIds.includes(d.PaymentPlan.Id))
      );
      if (affectedNextOrders.length > 0) {
        affectedNextOrders.forEach(no => {
          no.Details.forEach(d => {
            if (planIds.includes(d.PaymentPlan.Id)) {
              d.IsWorking = status === 1;
              d.PaymentPlan.CreateOrder = status === 1;
            }
          });
        });
      }

      if (args.orderId) {
        args.paymentPlanOrders.forEach(paymentOrder => {
          const detail = affectedNextOrders
            .reduce((a, b) => a.concat(b.Details), [])
            .find(d => d.PaymentPlan.Id === paymentOrder.paymentPlanId);
          if (detail) {
            detail.IsLocked = true;
            detail.OrderId = paymentOrder.paymentPlanOrderId;
          }
        })  
      }
    },
    fetch() {
      this.isLoading = true;
      Promise.all([
        this.fetchNext(),
        this.fetchPast(),
      ])
        .finally(() => {
          this.isLoading = false;
          this.initiated = true;
        });
    },

    fetchNext() {
      this.nextLoading = true;
      clientAPI.methods.getNextContractOrderDraftByContractId(this.contractId, this.nextDate)
        .then((response) => {
          //var endofYear = new Date(new Date().getFullYear(), 11, 31)
          //const data = response.filter(f => new Date(f.Order.CreatedDate) < endofYear);
          this.nextOrders = response.map(e => {
            //add vue observable prop flag to each detail
            // to monitor changes
            e.Details.forEach(d => {
              d.IsPaused = d.Overdue || false;
              d.IsWorking = false;
              d.IsLocked = false;
              d.OrderId = null;
            });
            return e;
          });
        })
        .finally(() => {
          this.nextLoading = false;
        });
    },

    fetchPast() {
      this.pastLoading = true;
      clientAPI.methods.getPastContractOrdersByContractId(this.contractId)
        .then((response) => {
          this.pastOrders = response;
        })
        .finally(() => {
          this.pastLoading = false;
        });
    },

    generateNextOrder() {
      //this.generateLoading = true;
      //clientAPI.methods.generateNextContractOrderByContractId(this.contractId, this.nextDate)
      //  .then(() => {
      //    this.fetchNext();
      //    this.fetchPast();
      //  })
      //  .finally(() => {
      //    this.generateLoading = false;
      //  });

      clientAPI.methods.generateContractOrdersFromPaymentPlans(
        this.nextOrders.flatMap(no => no.Details).filter(d => !(d.IsPaused || d.IsLocked)).map(d => d.PaymentPlan.Id)
      );
    },
  },

  computed: {
    IsWorking() {
      return this.nextOrders
        .reduce((a, b) => a.concat(b.Details), [])
        .some(o => o.IsWorking);
    },
    HasLines() {
      return this.nextOrders
        .reduce((a, b) => a.concat(b.Details), [])
        .some(o => !(o.IsPaused || o.IsLocked));
    },
    TotalAmountNextOrders() {
      if (this.nextOrders == null || this.nextOrders.length === 0) {
        return 0;
      }
      return this.nextOrders
        .reduce((a, b) => a.concat(b.Details), [])
        .filter(o => !(o.IsPaused || o.IsLocked))
        .map(o => o.Order.TotalAmountExclVat)
        .reduce((a, b) => a + b, 0);
    },
    contractId() {
      return this.$route.params.contractId;
    },

    // plain orders for chart (strip meta wrapper)
    pastOrdersPlain() {
      return (this.pastOrders || [])
        .map(m => m.Order)
        .filter(o => !!o);
    },
    // plain order for chart (strip meta wrapper)
    nextOrdersPlain() {
      return (this.nextOrders || [])
        .map(m => m.Order);
    },
  },

  watch: {
    contractId: function () {
      this.fetch();
    },

    nextDate: function () {
      this.fetchNext();
    }
  },
};
</script>


<style lang='scss' scoped></style>